var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"sns-button-wrapper",on:{"click":_setup.onClickFacebookLogin}},[_vm._t("default",function(){return [_c(_setup.SnsLogoCircle,{attrs:{"sns-name":"facebook","width":44,"height":44}})]}),_c('span',{staticClass:"a11y-hidden"},[_vm._v("페이스북으로 로그인")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }